import { FieldType } from '~/shared/domain/models';
import { cnpjMask } from './masks/cnpj';
import { cpfMask } from './masks/cpf';
import { currencyMask } from './masks/currency';
import { dateMask } from './masks/date';
import { emailMask } from './masks/email';
import { numberMask } from './masks/number';
import { phoneMask } from './masks/phone';
import { zipcodeMask } from './masks/zipcode';
import type { FieldValues, UseFormRegister } from 'react-hook-form';
import type { FieldTextSchema } from '~/shared/domain/models';

export const overrideRegister =
  <T extends FieldValues>(field: FieldTextSchema) =>
  (register: UseFormRegister<T>) => {
    const extraProps = { type: 'text' };
    let onChange = () => {};
    let setValueAs: any;

    switch (field.type) {
      case FieldType.cnpj:
        onChange = cnpjMask.onChange;
        setValueAs = cnpjMask.transform;
        break;
      case FieldType.cpf:
        onChange = cpfMask.onChange;
        setValueAs = cpfMask.transform;
        break;
      case FieldType.currency:
        onChange = currencyMask.onChange;
        setValueAs = currencyMask.transform;
        break;
      case FieldType.date:
        onChange = dateMask.onChange;
        setValueAs = dateMask.transform;
        break;
      case FieldType.number:
        extraProps.type = 'number';
        onChange = numberMask.onChange;
        setValueAs = numberMask.transform;
        break;
      case FieldType.tel:
        onChange = phoneMask.onChange;
        setValueAs = phoneMask.transform;
        break;
      case FieldType.zipcode:
        onChange = zipcodeMask.onChange;
        setValueAs = zipcodeMask.transform;
        break;
      case FieldType.email:
        onChange = emailMask.onChange;
        setValueAs = emailMask.transform;
        break;
    }

    const registerCustom: UseFormRegister<T> = (name, opts) => {
      return register(name, {
        ...opts,
        onChange,
        setValueAs,
      });
    };

    return registerCustom;
  };
